import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

// GET ALL PAYMENT METHOD
export const getPaymentMethods = createAsyncThunk('payments/getPaymentMethods', async (payload, thunkAPI) => {
  let mainUrl = `/payments`;

  if (payload) {
    mainUrl += `?total_payment=${payload}`;
  }

  try {
    const response = await axiosInstance.get(mainUrl);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});

// to update payment type from HALF to FULL

export const updatePaymentType = createAsyncThunk('payments/updatePaymentType', async (_, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/payments`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});
